import LoginStreamwell from "./login.streamwell";

const Login = () => {
  return <LoginStreamwell /> 
};

export default Login;
